import { NotificationService, LoaderService, EVENTO, TOOLTIPS, ICONS, ACTIONS } from "../../../../shared/session/index";
import { CustomValidators, RegularExpression, RegularExpressionMessage } from '../../../../shared/validation/customvalidation';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Rol } from "../shared/rol.model";
import { RolService } from "../shared/rol.service";

@Component({
  selector: 'app-rol-new',
  templateUrl: 'rol-new.component.html'
})
export class RolNewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;

  formGroupNewRol: FormGroup;
  msgErrorInsert: string;
  obligatorioMsg: string;
  rol: Rol;
  maxLengthMsg: string;
  nomRolMaxLength: number;
  descripcionMaxLength: number;
  nomRolPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_NUMERO_MSG;
  buttonGroup: any;

  constructor(
    private loaderService: LoaderService,
    private rolService: RolService,
    private notificationService: NotificationService,
    public fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.rol = new Rol();
    this.msgErrorInsert = 'Error al registrar Rol';
    this.titlePage = 'Completa los datos del Rol';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.maxLengthMsg = 'El tamaño máximo es de ';
    this.nomRolMaxLength = 100;
    this.descripcionMaxLength = 250;
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.setValuesFormBuilder();
  }

  setValuesFormBuilder() {
    this.formGroupNewRol = this.fb.group({
      Name: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomRolMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      shortName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomRolMaxLength),
      ])],
      description: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.descripcionMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
    });
  }

  changeEvent(rol: Rol) {
    this.data = { rol: { ID: rol.ID, Name: rol.Name } };
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }

  formGroupNewRolSubmit(event) {
    if (this.formGroupNewRol.invalid)
      return;
    this.rol.Name = event.value.Name;
    this.rol.shortName = event.value.shortName;
    this.rol.Description = event.value.description;
    this.insertarRol(this.rol);
  }

  insertarRol(rol: Rol) {
    this.loaderService.show();
    this.rolService.insertarRol(rol)
      .subscribe(res => {
        rol.ID = res;
        this.changeEvent(rol);
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          this.notificationService.error(this.msgErrorInsert);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}
